module.exports = __webpack_public_path__ + "img/ski_place4.f2224946.png";